import { Component, Prop, State, Watch, h } from '@stencil/core';
import { FinanceOption, Model, ModelWithTrim, Trim } from '../../types';
import { getModel, getTrim } from '../../utils/api';
import KIAImage from '../KIAImage';

@Component({
  tag: 'kia-priskort',
  styleUrl: 'kia-priskort.scss',
  shadow: false,
})
export class Priskort {
  @Prop() code: string | null = null;
  @Prop() modelWithTrim: ModelWithTrim | null = null;
  @Prop() pricelist: boolean = false;
  @Prop() vertical: boolean = true;
  @Prop() filteredType?: FinanceOption = undefined;
  @Prop() index: number = 0;
  @State() model: Model | null = null;
  @State() trim: Trim | null = null;
  @State() activeTrim: string | null = null;
  @State() sortedTrims: Trim[] = [];

  async componentWillLoad() {
    // If a single card
    if (!this.pricelist) {
      if (this.code) {
        const { data, status }: { data: Model; status: number } = await getModel(this.code);
        if (data && status === 200) {
          console.log(data);
          this.sortedTrims = this.sortTrims(data.visible_cars);
          this.model = data;
          this.activeTrim = this.sortedTrims[0].code;
          await this.loadTrim();
        }
      }
      // If pricelist
    } else {
      this.model = this.modelWithTrim;
      this.trim = this.modelWithTrim.first_car;
      this.sortedTrims = this.sortTrims(this.modelWithTrim.visible_cars);
    }
  }

  sortTrims = (trims: Trim[]) => {
    return trims.sort((a, b) => {
      if (a.price === b.price) {
        return a.name.localeCompare(b.name);
      } else {
        return a.price - b.price;
      }
    });
  };

  loadTrim = async () => {
    if (this.activeTrim) {
      const { data, status } = await getTrim(this.activeTrim);
      if (data && status === 200) {
        this.trim = data;
      }
    }
  };

  @Watch('activeTrim')
  async fetchNewData() {
    await this.loadTrim();
  }

  render() {
    return this.model ? (
      <div class={`kia_price_card ${!this.pricelist || this.vertical ? 'kia_price_card--big' : ''}`}>
        <div class="kia_price_card--image">{this.trim && <KIAImage alt={this.model?.name} loading={this.index === 0 ? 'eager' : 'lazy'} src={this.trim.image} />}</div>
        <div>
          <div class="kia_price_card--header">
            {this.model.type && <p>{this.model.type.name}</p>}
            <h3>{this.model?.name}</h3>
            {this.pricelist && (
              <a href={this.model.url} class="kia_price_card--link">
                <h5>Utforska bilen</h5>
                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.3335 11L6.3335 6L1.3335 1" stroke="#05141F" stroke-width="2" />
                </svg>
              </a>
            )}
          </div>
          <div class="kia_price_card--trims">
            <select aria-label="Byt trim" onChange={e => (this.activeTrim = (e.target as HTMLSelectElement).value)} name="trims" id="trims">
              {this.sortedTrims.map(c => (
                <option value={c.code}>{c.name}</option>
              ))}
            </select>
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.833496 1.5L5.8335 6.5L10.8335 1.5" stroke="#05141F" stroke-width="2" />
            </svg>
          </div>
          {this.filteredType && <p class="kia_price_card--description">{this.trim.description ?? this.model.description}</p>}
          {this.trim && <kia-trim model={this.model} pricelist={this.pricelist} trim={this.trim} />}
        </div>
      </div>
    ) : (
      <div class="kia_price_card">
        <p>Hittade ingen modell med kod {this.code}</p>
      </div>
    );
  }
}
